import { environment } from '../../../../environments/environment'
import { CustomFieldValue } from '../store/manage-subscription.state'

export const createCustomFieldWith = (customFieldId: string): CustomFieldValue => {
  return {
    customFieldId: customFieldId,
    name: getNameBy(customFieldId),
    value: ['TRUE'],
    values: ['TRUE'],
    type: 'text',
    fieldType: 'text',
    valueType: 'string',
  }
}

function getNameBy(customFieldId: string): string {
  switch (customFieldId) {
    case environment.uwg7Id:
      return 'uwg7'
    case environment.doiId:
      return 'werbeeinwilligung'
    default:
      return ''
  }
}
